import React, { useEffect, useRef } from 'react';

// Alerts (both errors and success messages) auto-dismiss after this long so
// they never linger on screen indefinitely.
const AUTO_DISMISS_MS = 5000;

export default function Alert({ type = 'success', message, onClose, autoDismissMs = AUTO_DISMISS_MS }) {
  // Keep the latest onClose without making it a dependency of the timer effect,
  // so an inline `() => setX(null)` doesn't reset the countdown on every render.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!message || !autoDismissMs || !onCloseRef.current) return undefined;
    const timer = setTimeout(() => onCloseRef.current && onCloseRef.current(), autoDismissMs);
    return () => clearTimeout(timer);
  }, [message, type, autoDismissMs]);

  if (!message) return null;
  return (
    <div className={`alert alert-${type}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: 14, padding: 0, width: 'auto' }}
        >
          <i className="ti ti-x" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}
